module.exports = {
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pingpp-js/src/stash.js
// module id = 6ylr
// module chunks = 5